import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {WaitingModalService} from "./../components/modal/waiting/waiting.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export abstract class AbstractLoadingResolver implements Resolve<any> {

  constructor(private waitingModal: WaitingModalService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | any {
    let observable = this.doResolve(route, state);
    if (observable != null) {
      if (observable.finally != null) {
        this.waitingModal.openModal();
        observable.subscribe(() => {
          this.onResolve();
        }, () => {
            this.onResolve();
        });
      } else if (observable.then != null) {
        this.waitingModal.openModal();
        observable.then(() => {
          this.onResolve();
        })
      }
    }
    return observable;
  }

  private onResolve() {
    this.waitingModal.closeModal();
  }

  abstract doResolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | any;

}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/services/abstract-loading.resolver.ts